module.exports = __webpack_public_path__ + "static/media/footstepf_on_fallen_dry_palm_leaves.3e923114.mp3";